export enum ScrollTimeout {
  default = 167, // in milliseconds
}

export enum PackingListFilterOptions {
  All = 'All',
  Packed = 'Packed',
  Unpacked = 'Unpacked',
}

export enum TabOptions {
  Personal = 'Personal',
  Shared = 'Shared',
}
